import {
  Template,
  TemplateSection,
} from '../../templates/models/templates.types';
import { TemplatesState } from '../../templates/stores/use-templates.store';

export const swapArrayElements = <T>(
  array: T[] | undefined,
  index1: number,
  index2: number
): T[] | undefined => {
  if (!array) return;
  const copy = [...array];
  if (
    index1 < 0 ||
    index2 < 0 ||
    index1 >= array.length ||
    index2 >= array.length
  )
    return array;
  [copy[index1], copy[index2]] = [copy[index2], copy[index1]];
  return copy;
};

export const getEmptyTemplate = (): Template => ({
  id: '',
  create_change_info: { changed_at: '', created_at: '', created_by: {} },
  preview_id: '',
  sections: [],
  settings: {
    description: '',
    extra: { restricted: false, unique: false },
    name: '',
    icon: { id: '', url: '' },
    purpose: undefined,
  },
});

/**
 * Move an element from one section to adjacent section (up or down).
 * Use this only inside a Zustand set() block with Immer enabled.
 */
export const moveElementBetweenSections = (
  state: TemplatesState,
  sectionId: string,
  elementIndex: number,
  up: boolean
) => {
  const sections = state.selectedTemplate?.sections;
  if (!sections) return;

  const currentSectionIndex = sections.findIndex((s) => s.id === sectionId);
  const targetSectionIndex = up
    ? currentSectionIndex - 1
    : currentSectionIndex + 1;

  // Boundary check
  if (
    currentSectionIndex < 0 ||
    targetSectionIndex < 0 ||
    targetSectionIndex >= sections.length
  ) {
    return;
  }

  const currentSection = sections[currentSectionIndex];
  const targetSection = sections[targetSectionIndex];

  if (
    !currentSection.elements ||
    elementIndex < 0 ||
    elementIndex >= currentSection.elements.length
  ) {
    return;
  }

  // Remove from current
  const [element] = currentSection.elements.splice(elementIndex, 1);
  if (!targetSection.elements) {
    targetSection.elements = [];
  }

  // Add to end of target
  targetSection.elements.push(element);
};
